import * as sharedTypes from 'src/actions/shared/sharedTypes';
import createDocumentResource, { handleStandardErrors } from 'src/actions/shared/createDocumentResource';
import emptyObserverCreator from 'src/actions/shared/emptyObserverCreator';
import set from 'lodash/set';

enum EntityTypes {
  HELP_CENTER = 'HELP_CENTER',
  CHAT = 'CHAT',
  GLAD_APP = 'GLAD_APP', // it's here to protect inconsistency with backend version and should be removed in the future
  SIDEKICK = 'SIDEKICK', // it's here to protect inconsistency with backend version and should be removed in the future
  ANSWER = 'ANSWER',
}

export class AudiencesReference {
  id: string;
  name: string;
  type: EntityTypes;
}

const audiencesReferencesResource = createDocumentResource<AudiencesReference>({
  name: 'audiencesReferences',
  endpoint: 'v1/orgs/:orgId/audiences/:id/references',
  type: AudiencesReference,
  observerCreator: emptyObserverCreator,
  reducers: {
    fetchStarted(state, action) {
      const audienceId = action.payload.audienceId;
      state.loadingStates[audienceId] = 'loading';
      state.errors = [];
    },
    fetchSuccess(state, action) {
      const audienceId = action.payload.audienceId;
      state.loadingStates[audienceId] = 'succeeded';
      set(state.value, `[${audienceId}]`, action.payload.result);
    },
  },
});

const fetch: sharedTypes.AppThunk =
  (params: any) =>
  async (dispatch, getState, { gateways }) => {
    const { fetchStarted, fetchSuccess, fetchError, fetchRequestError } = audiencesReferencesResource.actions;
    const { id: audienceId } = params;
    const audienceReferences = getState().audiencesReferences;
    const isAlreadyFetching = audienceReferences.loadingStates[audienceId] === 'loading';
    if (!isAlreadyFetching) {
      try {
        dispatch(fetchStarted({ audienceId }));
        const result = await gateways.audiencesReferences.request(params);
        dispatch(fetchSuccess({ audienceId, result }));
      } catch (error) {
        handleStandardErrors({ error, dispatch, handleDomainError: fetchError, handleDefaultError: fetchRequestError });
      }
    }
  };

audiencesReferencesResource.effects.fetch = fetch;

export default audiencesReferencesResource;
